import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { LockKey, ArrowLeft } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { BUSINESS } from "@/config";
import { toast } from "sonner";

export default function Login() {
  const { login, loginGoogle } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Creator");
      nav("/creator");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-background grain flex items-center justify-center px-5">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md relative z-10"
      >
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary mb-6" data-testid="back-home">
          <ArrowLeft size={16} /> Back to site
        </Link>
        <div className="border border-border bg-card p-8">
          <div className="flex items-center gap-2 mb-1">
            <span className="w-2.5 h-2.5 bg-primary rounded-full" />
            <span className="font-display font-black text-xl tracking-tighter uppercase">{BUSINESS.name}</span>
          </div>
          <div className="flex items-center gap-2 mt-6 text-primary">
            <LockKey size={22} weight="duotone" />
            <h1 className="font-display font-black text-3xl uppercase tracking-tight">Creator Login</h1>
          </div>
          <p className="text-sm text-muted-foreground mt-2">Access wholesale applications and moderate reviews.</p>

          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form">
            <Input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-background border-border rounded-sm h-12 focus-visible:ring-primary focus-visible:ring-1" data-testid="login-email" />
            <Input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-background border-border rounded-sm h-12 focus-visible:ring-primary focus-visible:ring-1" data-testid="login-password" />
            <button type="submit" disabled={loading} className="w-full bg-primary text-white font-bold py-3.5 rounded-sm hover:bg-red-500 transition-colors uppercase tracking-wide disabled:opacity-60" data-testid="login-submit">
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>

          <div className="flex items-center gap-3 my-5">
            <span className="h-px flex-1 bg-border" />
            <span className="text-xs text-muted-foreground uppercase tracking-widest">or</span>
            <span className="h-px flex-1 bg-border" />
          </div>

          <button
            onClick={loginGoogle}
            className="w-full flex items-center justify-center gap-3 border border-border bg-background hover:border-primary/60 py-3.5 rounded-sm font-bold uppercase tracking-wide text-sm transition-colors"
            data-testid="login-google"
          >
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" className="w-5 h-5" />
            Continue with Google
          </button>
          <p className="text-[11px] text-muted-foreground mt-3 text-center">Google access is restricted to the shop owner's email.</p>
        </div>
      </motion.div>
    </div>
  );
}
